import { type PreviewStaticModule } from '@/lib/builder/types'

import EmailHeader from './preview/EmailHeader.vue'

export const EmailHeadingStaticModule: PreviewStaticModule = {
  preview: EmailHeader,
}
